package br.com.texeratx.boardgametimeapp.core.storage

import br.com.texeratx.boardgametimeapp.core.theme.AppThemeMode
import kotlinx.browser.localStorage

class JsThemeStorage : ThemeStorage {
    override suspend fun saveTheme(theme: AppThemeMode) {
        localStorage.setItem("app_theme", theme.storageValue)
    }

    override suspend fun getTheme(): AppThemeMode? {
        val value = localStorage.getItem("app_theme")
        return AppThemeMode.fromStorage(value)
    }
}

actual fun provideThemeStorage(): ThemeStorage = JsThemeStorage()
